export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC: number = 10;
export const RES_PER_PAGE: number = 10;
export const API_KEY: string = "ee3c63e3-d67f-4671-ad7d-ebd9b9485813";
export const MODAL_CLOSE_SEC: number = 2.5;

export type Callback = () => void;
